import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import AdminLayout from 'hoc/AdminLayout';
import Dashboard from 'pages/admin/dashboard';
import Users from 'pages/admin/users';
import Payments from 'pages/admin/payments';
import Estate from 'pages/admin/estate';
import Schedule from 'pages/admin/schedule';
import EmailLogs from 'pages/admin/emailLogs';
import AlertSnapshots from 'pages/admin/alertSnapshots';
import PeakPrices from 'pages/admin/peakPrices';
import RealPriceUpload from 'pages/admin/realPriceUpload';

const Admin = () => {
  const adminToken = localStorage.getItem('adminToken');
  if (!adminToken) return <Navigate to="/admin/login" />;

  return (
    <Routes>
      <Route element={<AdminLayout />}>
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="users" element={<Users />} />
        <Route path="payments" element={<Payments />} />
        <Route path="estate" element={<Estate />} />
        <Route path="schedule" element={<Schedule />} />
        <Route path="email-logs" element={<EmailLogs />} />
        <Route path="alert-snapshots" element={<AlertSnapshots />} />
        <Route path="peak-prices" element={<PeakPrices />} />
        <Route path="real-price" element={<RealPriceUpload />} />
        <Route path="*" element={<Navigate to="dashboard" />} />
      </Route>
    </Routes>
  );
};

export default Admin;
